document.addEventListener("DOMContentLoaded", () => {
  const roots = document.querySelectorAll("[data-ir-before-after]");
  if (!roots.length) return;

  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

  const revealObserver=new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.classList.add("is-visible")
        revealObserver.unobserve(e.target)
      }
    })
  },{threshold:.25})

  document.querySelectorAll(".ir-before-after").forEach(s=>revealObserver.observe(s))

  roots.forEach((root) => {
    const media = root.querySelector("[data-ir-before-after-media]");
    const before = root.querySelector("[data-ir-before-after-before]");
    const handle = root.querySelector("[data-ir-before-after-handle]");
    if (!media || !before || !handle) return;

    const start = Number(root.getAttribute("data-start")) || 50;
    let pct = clamp(start, 0, 100);
    let dragging = false;

    const apply = () => {
      before.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      handle.style.left = `${pct}%`;
    };

    const setFromClientX = (clientX) => {
      const r = media.getBoundingClientRect();
      const x = clamp(clientX - r.left, 0, r.width);
      pct = (x / r.width) * 100;
      apply();
    };

    const onPointerDown = (e) => {
      dragging = true;
      media.setPointerCapture(e.pointerId);
      setFromClientX(e.clientX);
    };

    const onPointerMove = (e) => {
      if (!dragging) return;
      setFromClientX(e.clientX);
    };

    const onPointerUp = () => {
      dragging = false;
    };

    apply();

    media.addEventListener("pointerdown", onPointerDown);
    media.addEventListener("pointermove", onPointerMove);
    media.addEventListener("pointerup", onPointerUp);
    media.addEventListener("pointercancel", onPointerUp);

    window.addEventListener("resize", apply, { passive: true });
  });
});
